// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogShowerFlooringGuideRouteImport } from './routes/blog.shower-flooring-guide'
import { Route as AuthOtpRouteImport } from './routes/auth.otp'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard.index'
import { Route as AuthenticatedDashboardSitePhotosRouteImport } from './routes/_authenticated/dashboard.site-photos'
import { Route as AuthenticatedDashboardSettingsRouteImport } from './routes/_authenticated/dashboard.settings'
import { Route as AuthenticatedDashboardServicesRouteImport } from './routes/_authenticated/dashboard.services'
import { Route as AuthenticatedDashboardProjectsRouteImport } from './routes/_authenticated/dashboard.projects'
import { Route as AuthenticatedDashboardPagesRouteImport } from './routes/_authenticated/dashboard.pages'
import { Route as AuthenticatedDashboardMarkupRouteImport } from './routes/_authenticated/dashboard.markup'
import { Route as AuthenticatedDashboardImageVariantsRouteImport } from './routes/_authenticated/dashboard.image-variants'
import { Route as AuthenticatedDashboardFormRouteImport } from './routes/_authenticated/dashboard.form'
import { Route as AuthenticatedDashboardAnalyticsRouteImport } from './routes/_authenticated/dashboard.analytics'
import { Route as AuthenticatedDashboardAdminRouteImport } from './routes/_authenticated/dashboard.admin'
import { Route as AuthenticatedDashboardAdminIndexRouteImport } from './routes/_authenticated/dashboard.admin.index'
import { Route as AuthenticatedDashboardAdminSpeedRouteImport } from './routes/_authenticated/dashboard.admin.speed'
import { Route as AuthenticatedDashboardAdminSecurityRouteImport } from './routes/_authenticated/dashboard.admin.security'
import { Route as AuthenticatedDashboardAdminReportsRouteImport } from './routes/_authenticated/dashboard.admin.reports'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogShowerFlooringGuideRoute = BlogShowerFlooringGuideRouteImport.update({
            id: '/blog/shower-flooring-guide',path: '/blog/shower-flooring-guide',getParentRoute: () => rootRouteImport
          })
const AuthOtpRoute = AuthOtpRouteImport.update({
            id: '/otp',path: '/otp',getParentRoute: () => AuthRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardIndexRoute = AuthenticatedDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardSitePhotosRoute = AuthenticatedDashboardSitePhotosRouteImport.update({
            id: '/site-photos',path: '/site-photos',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardSettingsRoute = AuthenticatedDashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardServicesRoute = AuthenticatedDashboardServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardProjectsRoute = AuthenticatedDashboardProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardPagesRoute = AuthenticatedDashboardPagesRouteImport.update({
            id: '/pages',path: '/pages',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardMarkupRoute = AuthenticatedDashboardMarkupRouteImport.update({
            id: '/markup',path: '/markup',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardImageVariantsRoute = AuthenticatedDashboardImageVariantsRouteImport.update({
            id: '/image-variants',path: '/image-variants',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardFormRoute = AuthenticatedDashboardFormRouteImport.update({
            id: '/form',path: '/form',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardAnalyticsRoute = AuthenticatedDashboardAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardAdminRoute = AuthenticatedDashboardAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardAdminIndexRoute = AuthenticatedDashboardAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedDashboardAdminRoute
          })
const AuthenticatedDashboardAdminSpeedRoute = AuthenticatedDashboardAdminSpeedRouteImport.update({
            id: '/speed',path: '/speed',getParentRoute: () => AuthenticatedDashboardAdminRoute
          })
const AuthenticatedDashboardAdminSecurityRoute = AuthenticatedDashboardAdminSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AuthenticatedDashboardAdminRoute
          })
const AuthenticatedDashboardAdminReportsRoute = AuthenticatedDashboardAdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedDashboardAdminRoute
          })





const AuthenticatedDashboardAdminRouteChildren = {
  AuthenticatedDashboardAdminReportsRoute: AuthenticatedDashboardAdminReportsRoute,AuthenticatedDashboardAdminSecurityRoute: AuthenticatedDashboardAdminSecurityRoute,AuthenticatedDashboardAdminSpeedRoute: AuthenticatedDashboardAdminSpeedRoute,AuthenticatedDashboardAdminIndexRoute: AuthenticatedDashboardAdminIndexRoute
}

const AuthenticatedDashboardAdminRouteWithChildren = AuthenticatedDashboardAdminRoute._addFileChildren(AuthenticatedDashboardAdminRouteChildren)



const AuthenticatedDashboardRouteChildren = {
  AuthenticatedDashboardAdminRoute: AuthenticatedDashboardAdminRouteWithChildren,AuthenticatedDashboardAnalyticsRoute: AuthenticatedDashboardAnalyticsRoute,AuthenticatedDashboardFormRoute: AuthenticatedDashboardFormRoute,AuthenticatedDashboardImageVariantsRoute: AuthenticatedDashboardImageVariantsRoute,AuthenticatedDashboardMarkupRoute: AuthenticatedDashboardMarkupRoute,AuthenticatedDashboardPagesRoute: AuthenticatedDashboardPagesRoute,AuthenticatedDashboardProjectsRoute: AuthenticatedDashboardProjectsRoute,AuthenticatedDashboardServicesRoute: AuthenticatedDashboardServicesRoute,AuthenticatedDashboardSettingsRoute: AuthenticatedDashboardSettingsRoute,AuthenticatedDashboardSitePhotosRoute: AuthenticatedDashboardSitePhotosRoute,AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute
}

const AuthenticatedDashboardRouteWithChildren = AuthenticatedDashboardRoute._addFileChildren(AuthenticatedDashboardRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const AuthRouteChildren = {
  AuthOtpRoute: AuthOtpRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRouteWithChildren,ContactRoute: ContactRoute,ServicesRoute: ServicesRoute,UnsubscribeRoute: UnsubscribeRoute,BlogShowerFlooringGuideRoute: BlogShowerFlooringGuideRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)